import React from "react";
import {
  Row,
  Col,
  Form,
  Icon,
  Input,
  Button,
  Table,
  Tag,
  Select,
  DatePicker,
  Breadcrumb,
  Radio,
  message,
} from "antd";

import Axios from "../../util/request";
import moment from "moment";
import UpdataWorkers from "./components/UpdataWorkers";
import debounce from "lodash/debounce";
import Zmage from "react-zmage";
import { orgServices, recyclerServices } from "../../util/publicData";

const { Option } = Select;

class DriverList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        // isDriver: 1
      }, //检索数据
      dataSource: {}, //列表数据
      provinceList: [],
      pageNum: 1,
      tableLoading: true,
      projectNameMap: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
    };
    this.pageNum = 1;
    this.projectNameMap = [];
    this.fetchOrgData = debounce(this.fetchOrgData, 800);
    this.fetchData = debounce(this.fetchData, 800);
  }
  fetchData = (url, type) => {
    const self = this;
    //筛选下拉查询
    Axios({ url, method: "get" }, true).then((result) => {
      if (result.success) {
        let projectNameMap = [];
        projectNameMap = result.data.map((item) => {
          return { label: item.name, value: item.id };
        });
        self.setState({ projectNameMap });
      }
    });
  };

  // 获取table数据
  fetchOrgData = () => {
    const self = this;
    const { filterData, timeString } = this.state;
    const page = this.pageNum || 1;
    this.setState({ tableLoading: true });
    if (!filterData.state) {
      delete filterData.state;
    }

    const params = JSON.stringify(filterData);
    // 拉取预约数据
    Axios(
      {
        url: "/server/admin/worker/getWorkerList",
        data: { page, rows: 20, params },
        method: "get",
        type: "json",
      },
      true
    ).then((result) => {
      if (result.success) {
        self.setState({ dataSource: result, tableLoading: false });
      }
    });
  };

  getFormData = () => {
    const self = this;
    const { filterData, timeString } = this.state;
    const page = this.pageNum || 1;
    this.setState({ tableLoading: true });
    if (!filterData.state) {
      delete filterData.state;
    }

    const dataParam = {params: JSON.stringify(filterData)};

    let form = document.createElement("form");
    form.style.display = "none";
    form.action = `/server/admin/worker/getWorkerForm`;
    form.method = "get";
    document.body.appendChild(form);
    // 动态创建input并给value赋值

    const token = localStorage.getItem("token");
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = "token";
    input.value = token;
    form.appendChild(input);

    for (var key in dataParam) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = dataParam[key];
      form.appendChild(input);
    }

    form.submit();
    form.remove();

    // });
  };

  getProjectNameMap = () => {
    const self = this;
    Axios(
      {
        // url: "/server/admin/worker/getUserList",
        url: "/server/admin/project/getProjects",
        data: { page: 1, rows: 200, params: JSON.stringify({}) },
        method: "get",
        type: "json",
      },
      true
    ).then((result) => {
      if (result.success) {
        self.projectNameMap = result.data.map((item) => {
          return { label: item.name, value: item.id };
        });
        self.setState({
          projectNameMap: self.projectNameMap,
        });
      }
    });
  };
  componentDidMount() {
    const self = this;
    const { filterData, userInfo } = this.state;
    const { search } = this.props.location;
    const paramsString = search.substring(1);
    const searchParams = new URLSearchParams(paramsString);
    const sortersName = searchParams.get("sortersName");
    if (userInfo.projectId != null) {
      filterData.projectId = userInfo.projectId;
    }
    if (filterData) {
      filterData.sortersName = sortersName;
    }
    this.setState({ filterData }, function () {
      self.fetchOrgData();
    });
    this.getProjectNameMap();
  }

  render() {
    const self = this;
    const { filterData, tableLoading, userInfo } = this.state;
    const { match } = this.props;
    const dataColumns = [
      {
        title: "编号",
        dataIndex: "id",
        key: "id",
        render: (cur, record, index) => {
          return (self.pageNum - 1) * 20 + index + 1;
        },
      },
      {
        title: "姓名",
        dataIndex: "classifierName",
        key: "classifierName",
      },
      {
        title: "头像",
        dataIndex: "classifierHeadImg",
        key: "classifierHeadImg",
        render: (cur, record) => {
          return (
            <div style={{ textAlign: "center" }}>
              <Zmage
                edge={20}
                style={{ width: "60px", height: "60px", borderRadius: "50%" }}
                src={cur}
                set={cur}
                defaultPage={0}
              />
            </div>
          );
        },
      },
      {
        title: "手机号",
        dataIndex: "classifierMobile",
        key: "classifierMobile",
      },
      {
        title: "项目",
        dataIndex: "projectName",
        key: "projectName",
      },
      {
        title: "类型",
        dataIndex: "classifierType",
        key: "classifierType",
        render: (cur, record) => {
          return (
            <div>
              {((classifierType) => {
                return recyclerServices.map((d) => {
                  if (record[d.sqlName] == d.value) {
                    return d.label + " ";
                  } else {
                    return "";
                  }
                });
              })(cur)}
            </div>
          );
        },
      },
      {
        title: "状态",
        dataIndex: "state",
        key: "state",
        render: (cur, record) => {
          return (
            <div>
              {cur == 1 ? (
                <Tag color="#87d068">通过</Tag>
              ) : (
                <Tag color="#f50">不通过</Tag>
              )}
            </div>
          );
        },
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        key: "createTime",
        render: (qrcode, record) => {
          return <div>{qrcode && moment(qrcode).format("YYYY-MM-DD")} </div>;
        },
      },
      {
        title: "更新时间",
        dataIndex: "updateTime",
        key: "updateTime",
        render: (qrcode, record) => {
          return <div>{qrcode && moment(qrcode).format("YYYY-MM-DD")} </div>;
        },
      },
      {
        title: "操作",
        render: (qrcode, record) => {
          return (
            <div className="optbtn">
              <Button
                type="primary"
                icon="eye"
                title="查看"
                onClick={() =>
                  this.props.history.push(
                    "/admin/worker/workerDetail/" + record.id
                  )
                }
              ></Button>
              <Button
                type="primary"
                icon="edit"
                title="编辑"
                onClick={() => this.UpdataWorkers.showDetail(record)}
              ></Button>
            </div>
          );
        },
      },
    ];
    return (
      <div style={{ flex: 1 }}>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <Icon type="home" /> 首页
          </Breadcrumb.Item>
          <Breadcrumb.Item>服务人员管理</Breadcrumb.Item>
        </Breadcrumb>
        <div className="mt-20">
          <Form layout="inline" style={{ flex: 1 }}>
            <Form.Item label="员工名称">
              <Input
                placeholder="员工名称"
                allowClear
                onChange={(e) => {
                  const { filterData } = this.state;
                  filterData.sortersName = e.target.value;
                  this.setState({ filterData });
                }}
                value={filterData.sortersName}
                style={{ width: 200 }}
              ></Input>
            </Form.Item>
            <Form.Item label="员工电话">
              <Input
                placeholder="员工电话"
                allowClear
                onChange={(e) => {
                  const { filterData } = this.state;
                  filterData.classifierMobile = e.target.value;
                  this.setState({ filterData });
                }}
                style={{ width: 200 }}
              ></Input>
            </Form.Item>
            <Form.Item label="项目">
              <Select
                defaultValue={userInfo.projectId || undefined}
                disabled={userInfo.projectId != null ? true : false}
                onChange={(val) => {
                  const { filterData } = this.state;
                  filterData.projectId = val;
                  this.setState({ filterData });
                }}
                onSearch={(value) => {
                  self.fetchData(
                    "/server/admin/project/getProjects?projectName=" + value
                  );
                }}
                onSelect={() => {
                  self.setState({ projectNameMap: self.projectNameMap });
                }}
                placeholder="项目"
                style={{ width: 120 }}
                allowClear
                showSearch
                filterOption={false}
              >
                {this.state.projectNameMap.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="类型">
              <Select
                onChange={(val) => {
                  const { filterData } = this.state;
                  filterData.isType = val.trim();
                  this.setState({ filterData });
                }}
                placeholder="全部"
                defaultValue="全部"
                style={{ width: 120 }}
              >
                <Option key=" " value={" "}>
                  全部
                </Option>
                <Option key={1} value={"1"}>
                  司机
                </Option>
                <Option key={2} value={"2"}>
                  环卫
                </Option>
                <Option key={3} value={"3"}>
                  宣传员
                </Option>
                <Option key={4} value={"4"}>
                  志愿者
                </Option>
                <Option key={5} value={"5"}>
                  回收员
                </Option>
                <Option key={6} value={"6"}>
                  项目专员
                </Option>
              </Select>
            </Form.Item>
            <Form.Item label="状态">
              <Select
                onChange={(val) => {
                  const { filterData } = this.state;
                  filterData.state = val.trim();
                  this.setState({ filterData });
                }}
                placeholder="全部"
                defaultValue="全部"
                style={{ width: 120 }}
              >
                <Option key=" " value={" "}>
                  全部
                </Option>
                <Option key={1} value={"1"}>
                  正常
                </Option>
                <Option key={0} value={"0"}>
                  禁用
                </Option>
              </Select>
            </Form.Item>
            <Form.Item>
              <Button
                onClick={() => {
                  this.pageNum = 1;
                  this.fetchOrgData();
                }}
                type="primary"
              >
                搜索
              </Button>
            </Form.Item>
            <Form.Item>
              <Button onClick={() => {
                this.getFormData();
              }} type="primary">
                列表导出
              </Button>
            </Form.Item>
          </Form>
          <br />
          <div style={{ textAlign: "right" }}>
            <Form.Item>
              <Button
                onClick={() => {
                  this.UpdataWorkers.showDetail();
                }}
                type="primary"
              >
                新增员工
              </Button>
            </Form.Item>
          </div>
          <div className="card-container" style={{ marginTop: 20 }}>
            <Table
              loading={tableLoading}
              scroll={{ x: 1300 }}
              dataSource={this.state.dataSource.datas}
              pagination={{
                total: this.state.dataSource.total || 0,
                showTotal: (total) =>
                  `共 ${this.state.dataSource.total || 0} 条数据`,
                pageSize: 20,
                current: this.pageNum,
                onChange: (page) => {
                  this.pageNum = page;
                  this.fetchOrgData();
                },
              }}
              columns={dataColumns}
            />
          </div>
        </div>
        <UpdataWorkers
          fetchOrgData={this.fetchOrgData}
          onRef={(c) => (this.UpdataWorkers = c)}
        ></UpdataWorkers>
      </div>
    );
  }
}

export default DriverList;
